import { render, staticRenderFns } from "./ViewPdfDoc.vue?vue&type=template&id=2b5b98ba"
import script from "./ViewPdfDoc.vue?vue&type=script&lang=js"
export * from "./ViewPdfDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports